import React from "react";
import Link from "react-router-dom/Link.js";
import useChangeLanguage from "../../../logic/useChangeLanguage";

const Navbar = () => {
  const { _t } = useChangeLanguage();
  const isAuthenticated = !!localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/"; // Redirect to home after logout
  };

  return (
    <nav>
      <ul className="nav-menu">
        <li>
          <Link to="/">{_t("home")}</Link>
        </li>
        <li>
          <Link to="/informations">{_t("information")}</Link>
        </li>
        <li>
          <Link to="/annonce-communique">
            {_t("announcements_and_communications")}
          </Link>
        </li>
        {/* <li>
          <Link to="/galerie-photos">
            {_t("photo_gallery")}
          </Link>
        </li> */}
        <li>
          <Link to="/contacts">{_t("contacts")}</Link>
        </li>

        <li className="has-submenu">
          <Link to="/online-service">{_t("online_services")}</Link>
          <ul className="nav-submenu" aria-label="Sous-menu services en ligne">
            <li>
              <Link to="/online-service">Téléchargements</Link>
            </li>
            <li>
              <Link to="/declaration-accident">Déclaration d'accident</Link>
            </li>
            <li>
              <Link to="/client-consultation-cotisation-detaches">
                Consultation des cotisations pour les détaches
              </Link>
            </li>
            <li>
              <Link to="/client-consultation-cotisation-afilier">
                Consultation des cotisations pour les affiliés
              </Link>
            </li>
          </ul>
        </li>

        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.onpr.bi:2096/"
          >
            WebMail
          </a>
        </li>

        <li>
          <Link to="/se-connecter">{_t("login")}</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
